module.exports = __webpack_public_path__ + "housingStatic/img/jxgj1.308d50b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/park_bg/jxgj1.jpg
// module id = BejC
// module chunks = 2